var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-headline"},[_c('h1',[_vm._v(_vm._s(_vm.$props.title))]),_c('span',[_vm._v(_vm._s(_vm.$props.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }